var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7575 3.30996C4.39336 3.30996 3.2875 4.41582 3.2875 5.77996V20.16C3.2875 21.5241 4.39336 22.63 5.7575 22.63H20.1375C21.5016 22.63 22.6075 21.5241 22.6075 20.16V5.77996C22.6075 4.41582 21.5016 3.30996 20.1375 3.30996H5.7575ZM1.6875 5.77996C1.6875 3.53216 3.5097 1.70996 5.7575 1.70996H20.1375C22.3853 1.70996 24.2075 3.53216 24.2075 5.77996V20.16C24.2075 22.4078 22.3853 24.23 20.1375 24.23H5.7575C3.5097 24.23 1.6875 22.4078 1.6875 20.16V5.77996ZM9.57695 9.91992C8.53279 9.91992 7.9214 11.1149 8.57373 11.9588L8.57437 11.9597L11.9435 16.3287L11.9497 16.3365C12.4135 16.9224 13.2603 16.9757 13.7939 16.4966C13.8602 16.4505 13.9198 16.3941 13.9703 16.3286L17.3395 11.9597L17.3402 11.9589C17.9925 11.115 17.3811 9.91992 16.337 9.91992H13.9453V6.42969C13.9453 5.8774 13.4976 5.42969 12.9453 5.42969C12.393 5.42969 11.9453 5.8774 11.9453 6.42969V9.91992H9.57695ZM6.16719 18.7695C5.72536 18.7695 5.36719 19.1277 5.36719 19.5695C5.36719 20.0114 5.72536 20.3695 6.16719 20.3695H19.8272C20.269 20.3695 20.6272 20.0114 20.6272 19.5695C20.6272 19.1277 20.269 18.7695 19.8272 18.7695H6.16719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.87ea1bfb8c60ab095b5e53fcf1d889b0.svg";
export { ForwardRef as ReactComponent };